import React from 'react'
import type { OpportunitySignals } from '../services/signalsService'
import { computeOpportunityPnl } from '../utils/pnl'
import { cn } from '@/lib/utils'

type Props = {
  signals: OpportunitySignals | null
  className?: string
}

export function OpportunityPnlBadge({ signals, className }: Props) {
  const info = React.useMemo(() => computeOpportunityPnl(signals), [signals])

  if (!info.label) return null

  const colorClass =
    info.variant === 'positive'
      ? 'text-emerald-400'
      : info.variant === 'negative'
      ? 'text-red-400'
      : 'text-foreground/70'

  return (
    <div
      className={cn(
        'flex items-center justify-end text-[10px] sm:text-[11px] font-semibold',
        className,
      )}
    >
      <span className={cn('whitespace-nowrap', colorClass)}>{info.label}</span>
    </div>
  )
}
